
export const SEARCH_CARD_TYPE = {
    disneyParkBlog: 'disneyParkBlog',
    planDisney: 'planDisney',
    faq: 'faq'
};

export const SEARCH_PARK_TYPE = {
    resort: 'resorts',
    destination: 'destinations'
};

export const SEARCH_SCHEDULE_TYPE = {
    quickService: 'Quick Service',
    closed: 'Closed',
    fixPrice: 'Prix Fixe Menu',
    fixPriceAll: 'Set Menu (all-you-care-to-eat)',
    aLaCarte: 'A la Carte',
    performanceTime: 'Performance Time',
    operating: 'Operating',
    familyStyle: 'Family-style',
    buffet: 'Buffet',
    characterDining: 'Character Dining',
};
